import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query"
// own
import {authReducer, loadAuthData, logoutLocal} from "./slices/authSlice";

// Систем тохиргоо
import { userApi } from "./apis/base/userApi";
import { organizationApi } from "./apis/base/organizationApi";
import { legalEntityApi } from "./apis/base/legalEntityApi";
import { staffApi } from "./apis/base/staffApi";
import { positionApi } from "./apis/base/positionApi";
import { departmentApi } from "./apis/base/departmentApi";
import { roleApi } from "./apis/base/roleApi";
import { menuApi } from "./apis/base/menuApi";
import { userRoleApi } from "./apis/base/userRoleApi";
import { commonDataApi } from "./apis/base/commonDataApi";
import { menuRoleApi } from "./apis/base/menuRoleApi";
import { menuPermissionApi } from "./apis/base/menuPermissionApi";
import { menuRolePermissionApi } from "./apis/base/menuRolePermissionApi";
import { notificationApi } from "./apis/base/notificationApi";
import { statusApi } from "./apis/base/statusApi";

// Шинжилгээ
import { labratorApi } from "./apis/core/labrator/labrator";
import { labratorDetailApi } from "./apis/core/labrator/labratorDetailApi";

// Хэмжилт API
import { meaLakeApi } from "./apis/core/measurement/meaLakeApi";
import { meaRiverApi } from "./apis/core/measurement/meaRiverApi";
import { meaSpringApi } from "./apis/core/measurement/meaSpringApi";
import { meaGlacierApi } from "./apis/core/measurement/meaGlacierApi";

import { meaMineralApi } from "./apis/core/measurement/meaMineralApi";

import { meaPurificationApi } from "./apis/core/measurement/meaPurificationApi";
import { meaIrrigationApi } from "./apis/core/measurement/meaIrrigationApi";
import { meaDamApi } from "./apis/core/measurement/meaDamApi";
import { meaPoolApi } from "./apis/core/measurement/meaPoolApi";
import { meaHydropowerApi } from "./apis/core/measurement/meaHydropowerApi";

import { meaUnderWaterApi } from "./apis/core/measurement/meaUnderWaterApi";
import { BoreholeApi } from "./apis/core/Parameter/Groundwater/BoreholeApi";
import { WaterBearingApi } from "./apis/core/Parameter/Groundwater/WaterBearingApi";
import { StorageApi } from "./apis/core/Parameter/Groundwater/StorageApi";

// Нийтлэг API
import { UsageApi } from "./apis/core/common/UsageApi";
import { safetyApi } from "./apis/core/common/safetyApi";
import { ownerApi } from "./apis/core/common/ownerApi";
import { DocumentUploadApi } from "./apis/core/common/DocumentApi";

// Гадаргын ус 
import { lakeApi } from "./apis/core/surfaceWater/lakeApi";
import { lakeShapeApi } from "./apis/core/surfaceWater/lakeShapeApi";
import { riverApi } from "./apis/core/surfaceWater/riverApi";
import { springApi } from "./apis/core/surfaceWater/springApi";
import { glacierApi } from "./apis/core/surfaceWater/glacierApi";
import { normalzoneApi } from "./apis/core/surfaceWater/normalzoneApi";


// Газрын доорх ус
import { groundwaterApi } from "./apis/core/undergroundWater/groundwaterApi";
import { wellApi } from "./apis/core/undergroundWater/WellApi";
import { meaWellApi } from "./apis/core/measurement/meaWellApi";
import { WellWaterBearingApi } from "./apis/core/Parameter/Well/WaterBearingApi";


// Рашаан
import { mineralApi } from "./apis/core/mineral/mineralApi";

// Усан байгууламж
import { purificationApi } from "./apis/core/construction/purificationApi";
import { irrigationApi } from "./apis/core/construction/irrigationApi";
import { damApi } from "./apis/core/construction/damApi";
import { poolPondApi } from "./apis/core/construction/poolPondApi";
import { hydropowerApi } from "./apis/core/construction/hydropowerApi";

// Au1
import { au1Api } from "./apis/boundary/au1";

// template with 
import LayoutReducer from "../slices/layouts/reducer";
import LoginReducer from "../slices/auth/login/reducer";
import ProfileReducer from "../slices/auth/profile/reducer";
import ForgotPasswordReducer from "../slices/auth/forgetpwd/reducer";
import AccountReducer from "../slices/auth/register/reducer";
import { au2Api } from "./apis/boundary/au2";
import { au3Api } from "./apis/boundary/au3";
import { basinApi } from "./apis/boundary/basin";
import { boreholeApi } from "./apis/core/undergroundWater/BoreholeApi";
import { meaBoreholeApi } from "./apis/core/measurement/meaBoroholeApi";
import { boreholeWaterBearingApi } from "./apis/core/Parameter/Borohole/WaterBearingApi";
import { workReportApi } from "./apis/core/workReportApi";
import { fromCircle } from "ol/geom/Polygon";
import { auditLogdApi } from "./apis/base/auditLogApi";
import { jobDayApi } from "./apis/core/jobDayApi";


export const store= configureStore({
    reducer: {
        auth: authReducer,
        Layout: LayoutReducer,
        Login: LoginReducer,
        Profile: ProfileReducer,
        ForgetPassword: ForgotPasswordReducer,
        Account: AccountReducer,
        [userApi.reducerPath]: userApi.reducer,
        [organizationApi.reducerPath]: organizationApi.reducer,
        [legalEntityApi.reducerPath]: legalEntityApi.reducer,
        [staffApi.reducerPath]: staffApi.reducer,
        [positionApi.reducerPath]: positionApi.reducer,
        [departmentApi.reducerPath]: departmentApi.reducer,
        [roleApi.reducerPath]: roleApi.reducer,
        [menuApi.reducerPath]: menuApi.reducer,
        [userRoleApi.reducerPath]: userRoleApi.reducer,
        [auditLogdApi.reducerPath]: auditLogdApi.reducer,
        [commonDataApi.reducerPath]: commonDataApi.reducer,
        [menuRoleApi.reducerPath]: menuRoleApi.reducer,
    
        [menuPermissionApi.reducerPath]: menuPermissionApi.reducer,
        [menuRolePermissionApi.reducerPath]: menuRolePermissionApi.reducer,
        [notificationApi.reducerPath]: notificationApi.reducer,
        [statusApi.reducerPath]: statusApi.reducer,

        [labratorApi.reducerPath]: labratorApi.reducer,
        [labratorDetailApi.reducerPath]: labratorDetailApi.reducer,

        [UsageApi.reducerPath]: UsageApi.reducer,
        [safetyApi.reducerPath]: safetyApi.reducer,
        [ownerApi.reducerPath]: ownerApi.reducer,
        [DocumentUploadApi.reducerPath]: DocumentUploadApi.reducer,

        [meaLakeApi.reducerPath]: meaLakeApi.reducer,
        [meaRiverApi.reducerPath]: meaRiverApi.reducer,
        [meaSpringApi.reducerPath]: meaSpringApi.reducer,
        [meaGlacierApi.reducerPath]: meaGlacierApi.reducer,
        [meaMineralApi.reducerPath]: meaMineralApi.reducer,
        [meaPurificationApi.reducerPath]: meaPurificationApi.reducer,
        [meaIrrigationApi.reducerPath]: meaIrrigationApi.reducer,
        [meaDamApi.reducerPath]: meaDamApi.reducer,
        [meaPoolApi.reducerPath]: meaPoolApi.reducer,
        [meaHydropowerApi.reducerPath]: meaHydropowerApi.reducer,
        [meaUnderWaterApi.reducerPath]: meaUnderWaterApi.reducer,
        [BoreholeApi.reducerPath]: BoreholeApi.reducer,
        [WaterBearingApi.reducerPath]: WaterBearingApi.reducer,
        [StorageApi.reducerPath]: StorageApi.reducer,

        [wellApi.reducerPath]: wellApi.reducer,
        [meaWellApi.reducerPath]: meaWellApi.reducer,
        [WellWaterBearingApi.reducerPath]: WellWaterBearingApi.reducer,

        [boreholeApi.reducerPath]: boreholeApi.reducer,
        [meaBoreholeApi.reducerPath]: meaBoreholeApi.reducer,
        [boreholeWaterBearingApi.reducerPath]: boreholeWaterBearingApi.reducer,
        
        
        
        [lakeApi.reducerPath]: lakeApi.reducer,
        [lakeShapeApi.reducerPath]:lakeShapeApi.reducer,
        [riverApi.reducerPath]: riverApi.reducer,
        [springApi.reducerPath]: springApi.reducer,
        [glacierApi.reducerPath]: glacierApi.reducer,
        [mineralApi.reducerPath]: mineralApi.reducer,
        [normalzoneApi.reducerPath]: normalzoneApi.reducer,

        [groundwaterApi.reducerPath]: groundwaterApi.reducer,
        
        [purificationApi.reducerPath]: purificationApi.reducer,
        [irrigationApi.reducerPath]: irrigationApi.reducer,
        [damApi.reducerPath]: damApi.reducer,
        [poolPondApi.reducerPath]: poolPondApi.reducer,
        [hydropowerApi.reducerPath]: hydropowerApi.reducer,

        
        [au1Api.reducerPath]: au1Api.reducer,
        [au2Api.reducerPath]: au2Api.reducer,
        [au3Api.reducerPath]: au3Api.reducer,
        [basinApi.reducerPath]: basinApi.reducer,

        [workReportApi.reducerPath]: workReportApi.reducer,
        [jobDayApi.reducerPath]:jobDayApi.reducer
        
    },
    middleware: (getDefaultMiddleware) =>{
        return getDefaultMiddleware()
        .concat(userApi.middleware)
        .concat(organizationApi.middleware)
        .concat(legalEntityApi.middleware)
        .concat(staffApi.middleware)
        .concat(positionApi.middleware)
        .concat(departmentApi.middleware)
        .concat(roleApi.middleware)
        .concat(menuApi.middleware)
        .concat(userRoleApi.middleware)
        .concat(auditLogdApi.middleware)   
        .concat(commonDataApi.middleware)
        .concat(menuRoleApi.middleware)

        .concat(menuPermissionApi.middleware)
        .concat(menuRolePermissionApi.middleware)
        .concat(notificationApi.middleware)
        .concat(statusApi.middleware)

        .concat(labratorApi.middleware)
        .concat(labratorDetailApi.middleware)
        
        .concat(UsageApi.middleware)
        .concat(safetyApi.middleware)
        .concat(ownerApi.middleware)
        .concat(DocumentUploadApi.middleware)

        .concat(meaLakeApi.middleware)        
        .concat(meaRiverApi.middleware)
        .concat(meaSpringApi.middleware)  
        .concat(meaGlacierApi.middleware)  
        .concat(meaMineralApi.middleware)  
        .concat(meaPurificationApi.middleware)  
        .concat(meaIrrigationApi.middleware)  
        .concat(meaDamApi.middleware)  
        .concat(meaPoolApi.middleware)  
        .concat(meaHydropowerApi.middleware)  
        .concat(meaUnderWaterApi.middleware)  
        .concat(BoreholeApi.middleware)  
        .concat(WaterBearingApi.middleware)  
        .concat(StorageApi.middleware)  

        .concat(wellApi.middleware)  
        .concat(meaWellApi.middleware)  
        .concat(WellWaterBearingApi.middleware)  

        .concat(boreholeApi.middleware)  
        .concat(meaBoreholeApi.middleware)  
        .concat(boreholeWaterBearingApi.middleware)  

        .concat(lakeApi.middleware)
        .concat(lakeShapeApi.middleware)
        .concat(riverApi.middleware)
        .concat(springApi.middleware)      
        .concat(glacierApi.middleware)   
        .concat(mineralApi.middleware)  
        .concat(normalzoneApi.middleware)

        .concat(purificationApi.middleware)  
        .concat(irrigationApi.middleware)  
        .concat(damApi.middleware)
        .concat(poolPondApi.middleware)
        .concat(hydropowerApi.middleware)
        .concat(groundwaterApi.middleware)

        .concat(au1Api.middleware)
        .concat(au2Api.middleware)
        .concat(au3Api.middleware)        
        .concat(basinApi.middleware)        

        .concat(workReportApi.middleware)
        .concat(jobDayApi.middleware)
        
    }
})

setupListeners(store.dispatch);

export { loadAuthData, logoutLocal};

export * from './thunks/authThunks';
export * from './apis/base/userApi';
export * from './apis/base/organizationApi';
export * from './apis/base/legalEntityApi';
export * from './apis/base/staffApi';
export * from './apis/base/positionApi';
export * from './apis/base/departmentApi';
export * from './apis/base/roleApi';
export * from './apis/base/menuApi';
export * from './apis/base/userRoleApi';
export * from './apis/base/auditLogApi';
export * from './apis/base/commonDataApi';

export * from './apis/base/menuRoleApi';
export * from './apis/base/menuPermissionApi';
export * from './apis/base/menuRolePermissionApi';
export * from './apis/base/notificationApi';
export * from './apis/base/statusApi';

export * from './apis/core/labrator/labrator';
export * from './apis/core/labrator/labratorDetailApi';

export * from './apis/core/common/UsageApi';
export * from './apis/core/common/safetyApi';
export * from './apis/core/common/ownerApi';
export * from './apis/core/common/DocumentApi';

export * from './apis/core/surfaceWater/riverApi';
export * from './apis/core/surfaceWater/springApi';
export * from './apis/core/surfaceWater/glacierApi';
export * from './apis/core/surfaceWater/lakeApi';
export * from './apis/core/surfaceWater/lakeShapeApi';
export * from './apis/core/surfaceWater/normalzoneApi';

export * from './apis/core/undergroundWater/groundwaterApi';
export * from './apis/core/undergroundWater/WellApi';
export * from './apis/core/undergroundWater/BoreholeApi';
export * from './apis/core/measurement/meaBoroholeApi';
export * from './apis/core/Parameter/Borohole/WaterBearingApi';


export * from './apis/core/mineral/mineralApi';

export * from './apis/core/measurement/meaLakeApi';
export * from './apis/core/measurement/meaRiverApi';
export * from './apis/core/measurement/meaSpringApi';
export * from './apis/core/measurement/meaGlacierApi';
export * from './apis/core/measurement/meaMineralApi';
export * from './apis/core/measurement/meaPurificationApi';
export * from './apis/core/measurement/meaIrrigationApi';
export * from './apis/core/measurement/meaDamApi';
export * from './apis/core/measurement/meaPoolApi';
export * from './apis/core/measurement/meaHydropowerApi';
export * from './apis/core/measurement/meaUnderWaterApi';
export * from './apis/core/Parameter/Groundwater/BoreholeApi';
export * from './apis/core/Parameter/Groundwater/WaterBearingApi';
export * from './apis/core/Parameter/Groundwater/StorageApi';
export * from './apis/core/measurement/meaWellApi';
export * from './apis/core/Parameter/Well/WaterBearingApi';

export * from './apis/core/construction/purificationApi';
export * from './apis/core/construction/irrigationApi';
export * from './apis/core/construction/damApi';
export * from './apis/core/construction/poolPondApi';
export * from './apis/core/construction/hydropowerApi';

export * from './apis/boundary/basin';
export * from './apis/boundary/au1';
export * from './apis/boundary/au2';
export * from './apis/boundary/au3';

export * from './apis/core/workReportApi';
export * from  './apis/core/jobDayApi';


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;